import { gql } from 'apollo-angular'

import { AUTHOR_EXTENDED_FIELDS } from '../../fragments/author.fragments'
import { CATEGORY_BASIC_FIELDS } from '../../fragments/category.fragment'
import { EDITION_LINK_FIELDS } from '../../fragments/edition.fragment'

const SEARCH_ARTICLE_BASIC_FIELDS = gql`
  fragment SearchArticleBasicFields on Article {
    id
    slug
    title
    content_preview
    published_at
    article_type
    udh_id
    updatedAt
  }
`

const SEARCH_ARTICLE_DETAIL_FIELDS = gql`
  fragment SearchArticleDetailFields on Article {
    users {
      authors {
        ...AuthorExtendedFields
      }
      creators {
        ...AuthorExtendedFields
      }
    }
    edition {
      ...EditionLinkFields
    }
    magazine {
      id
      title
      language
      slug
      abbreviation
      manual_title
      manual_description
      manual_url
    }
    categories {
      ...CategoryBasicFields
    }
  }
  ${EDITION_LINK_FIELDS}
  ${AUTHOR_EXTENDED_FIELDS}
  ${CATEGORY_BASIC_FIELDS}
`

export const SEARCH_ARTICLES = gql`
  query SearchArticles(
    $whereClause: Article_where
    $page: Int
    $limit: Int
    $sort: String
  ) {
    Articles(where: $whereClause, page: $page, limit: $limit, sort: $sort) {
      docs {
        ...SearchArticleBasicFields
        ...SearchArticleDetailFields
      }
      totalDocs
      page
      totalPages
    }
  }
  ${SEARCH_ARTICLE_BASIC_FIELDS}
  ${SEARCH_ARTICLE_DETAIL_FIELDS}
`
